module.exports = __webpack_public_path__ + "static/4-3b435e087c2be299d0e7eb0a54e34fd3.jpg";